<button
  *ngIf="type === 'emoji-button'"
  (click)="onAppButtonClick()"
  [disabled]="isButtonDisabled"
  [matTooltip]="
    (!!hoverTextTranslationKey ? hoverTextTranslationKey + '' : '') | translate
  "
  mat-icon-button
  matTooltipPosition="above"
  [matTooltipClass]="
    raiseHandTooltipClass
      ? 'app-button__tooltip ' + raiseHandTooltipClass
      : 'app-button__tooltip'
  "
  type="button"
  class="app-button__emoji"
>
  <ng-content select="[emoji]"></ng-content>
</button>

<button
  *ngIf="type === ''"
  class="app-button__button"
  (click)="onAppButtonClick()"
  [attr.data-e2e]="!e2e ? null : e2e + '--button'"
  [color]="color"
  [disabled]="isButtonDisabled"
  [class.app-button__transparent--disabled]="
    isButtonDisabled && transparentOnDisabled
  "
  appHoverbox
  mat-icon-button
  type="button"
  blurOnClick
>
  <span>
    <app-svg-icon
      [fill]="iconFill"
      [icon]="iconName"
      [size]="iconSize"
      [e2e]="e2e"
    ></app-svg-icon>
    <span class="app-button__underline" [ngClass]="underlinedColor"></span>
  </span>

  <ng-content></ng-content>

  <ng-template *ngTemplateOutlet="hoverTooltip"></ng-template>
</button>

<button
  *ngIf="isBasicIconTextButton"
  class="app-button__button app-button__icon-text-button"
  (click)="onAppButtonClick()"
  [attr.data-e2e]="!e2e ? null : e2e + '--button'"
  [disabled]="isButtonDisabled"
  [class.app-button__transparent--disabled]="
    isButtonDisabled && transparentOnDisabled
  "
  mat-menu-item
  type="{{ buttonType }}"
  blurOnClick
>
  <span class="app-button__button-icon">
    <app-svg-icon
      [fill]="iconFill"
      [icon]="iconName"
      [size]="iconSize"
      [e2e]="e2e"
    ></app-svg-icon>
  </span>

  <span class="app-button__button-text {{ color }}">
    {{ buttonTextTranslationKey | translate }}
  </span>
</button>

<button
  *ngIf="isBasicButton"
  class="app-button__button"
  [ngClass]="[textColor, size]"
  (click)="onAppButtonClick()"
  [attr.data-e2e]="!e2e ? null : e2e + '--button'"
  [color]="color"
  [disabled]="isButtonDisabled"
  [tabindex]="tabindex"
  [class.app-button__transparent--disabled]="
    isButtonDisabled && transparentOnDisabled
  "
  appHoverbox
  mat-button
  type="{{ buttonType }}"
  blurOnClick
>
  <ng-template *ngTemplateOutlet="hoverTooltip"></ng-template>
  <ng-template *ngTemplateOutlet="content"></ng-template>
</button>

<button
  *ngIf="isRaisedButton"
  class="app-button__button"
  [ngClass]="[textColor, size]"
  (click)="onAppButtonClick()"
  [attr.data-e2e]="!e2e ? null : e2e + '--button'"
  [color]="color"
  [disabled]="isButtonDisabled"
  [tabindex]="tabindex"
  [class.app-button__transparent--disabled]="
    isButtonDisabled && transparentOnDisabled
  "
  mat-raised-button
  type="{{ buttonType }}"
  blurOnClick
>
  <ng-template *ngTemplateOutlet="content"></ng-template>
</button>

<button
  *ngIf="isStrokedButton"
  class="app-button__button"
  [ngClass]="[textColor, size]"
  (click)="onAppButtonClick()"
  [attr.data-e2e]="!e2e ? null : e2e + '--button'"
  [color]="color"
  [disabled]="isButtonDisabled"
  [tabindex]="tabindex"
  [class.app-button__transparent--disabled]="
    isButtonDisabled && transparentOnDisabled
  "
  mat-stroked-button
  type="{{ buttonType }}"
  blurOnClick
>
  <ng-template *ngTemplateOutlet="content"></ng-template>
</button>

<!-- Button text and additional ng-content -->
<ng-template #content>
  <div *ngIf="buttonTextTranslationKey" ellipsisTitle>
    <ng-container
      *ngIf="
        !buttonTextTranslationKey?.translateParams;
        else useTranslateParams
      "
    >
      {{ buttonTextTranslationKey | translate | letterCase }}
    </ng-container>

    <ng-template #useTranslateParams>
      {{
        buttonTextTranslationKey.translationKey
          | translate: buttonTextTranslationKey?.translateParams
          | letterCase
      }}
    </ng-template>
  </div>

  <ng-content></ng-content>
</ng-template>

<!-- Hoverbox -->
<ng-template #hoverTooltip>
  <hoverbox *ngIf="hoverTextTranslationKey" [showAlways]="isHoverboxVisible">
    <ng-container
      *ngIf="!hoverTextTranslationKey?.translateParams; else useTranslateParams"
    >
      {{ hoverTextTranslationKey | translate }}
    </ng-container>

    <ng-template #useTranslateParams>
      {{
        hoverTextTranslationKey.translationKey
          | translate: hoverTextTranslationKey?.translateParams
      }}
    </ng-template>
  </hoverbox>
</ng-template>
